<script>
import TopBar from '@components/top-bar'
import OnlineStatus from "@components/global/OnlineStatus";
import CloudSidebar from "@views/cloud/CloudSidebar";
export default {
  components: { TopBar, OnlineStatus, CloudSidebar },
  data() {
    return {
      user: this.$store ? this.$store.state.auth.currentUser : {} || {},
    }
  },
  created: () => {
    document.body.classList.remove('authentication-bg');
    document.body.classList.remove('authentication-bg-pattern');
  },
}
</script>

<style lang="scss">
#cloud-home {
  min-height: calc(100vh - #{$topbar-height});
  padding-top: $topbar-height;
  display: flex;

  @media (max-width: 991px) {
    flex-direction: column;
  }

  .cloud-base-content {
    flex: 1;
    min-width: 0;
    max-height: calc(100vh - #{$topbar-height});
    overflow-y: auto;
    padding: 1.5rem 2rem;

    @media (max-width: 991px) {
      padding: 1rem;
      max-height: none;
    }
  }
}

.cloud-unavailable-wrap {
  min-height: calc(100vh - #{$topbar-height});
  padding: calc(#{$topbar-height} + 1.5rem) 2rem 2rem;
}
</style>
<template>
  <div>
    <header id="topnav">
      <TopBar/>
    </header>
    <div v-if="!isEducational && !isOfflineVersion" id="cloud-home">
      <cloud-sidebar/>
      <div class="cloud-base-content">
        <slot/>
      </div>
    </div>
    <div v-else class="cloud-unavailable-wrap">
      <educational-unavailable/>
    </div>
    <OnlineStatus/>
  </div>
</template>
